import React from "react";

// Line-art Amelia Island Lighthouse, modeled on the News-Leader masthead mark.
export default function Lighthouse({ className }) {
  return (
    <svg aria-hidden viewBox="0 0 140 260" fill="none" stroke="currentColor" strokeLinejoin="round" strokeLinecap="round" className={className}>
      <g strokeWidth="1.6">
        <path d="M70 6v14" />
        <circle cx="70" cy="22" r="2.6" />
        <path d="M54 44c0-10 7-19 16-19s16 9 16 19" />
        <path d="M52 44h36M50 48h40" />
        <path d="M54 48v28M86 48v28M62 48v28M70 48v28M78 48v28" strokeWidth="1.1" />
        <path d="M54 48l8 14M62 48l8 14M70 48l8 14M78 48l8 14M62 62l-8 14M70 62l-8 14M78 62l-8 14M86 62l-8 14" strokeWidth="0.6" opacity="0.7" />
        <path d="M44 76h52M42 82h56" strokeWidth="1.8" />
        <path d="M42 82v-8M48 82v-8M54 82v-8M60 82v-8M66 82v-8M74 82v-8M80 82v-8M86 82v-8M92 82v-8M98 82v-8" strokeWidth="0.9" />
        <path d="M46 82l4 8h40l4-8" />
        <path d="M50 90 40 232M90 90l10 142" strokeWidth="1.8" />
        <path d="M48.6 110h42.8M46.6 140h46.8M44.4 170h51.2M42.2 200h55.6" strokeWidth="0.8" opacity="0.55" />
        <path d="M66 118h8v12h-8zM65 152h10v13H65z" strokeWidth="1.1" />
        <path d="M70 118v12M70 152v13" strokeWidth="0.6" />
        <path d="M62 232v-16a8 8 0 0 1 16 0v16" strokeWidth="1.3" />
        <path d="M34 232h72M28 240h84" strokeWidth="1.8" />
        <path d="M6 252c14-5 26-5 40 0s26 5 40 0 26-5 48 0" strokeWidth="1" opacity="0.6" />
      </g>
    </svg>
  );
}
